<div id="blank-layout">
  <router-outlet></router-outlet>
</div>
